import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { SchedulingAssignment } from "@/actions/ssr/scheduling/getSchedulingAssignmentsSSR";

interface SchedulingAssignmentsState {
  assignments: SchedulingAssignment[];
  isLoading: boolean;
}

const initialState: SchedulingAssignmentsState = {
  assignments: [],
  isLoading: false,
};

const schedulingAssignmentsSlice = createSlice({
  name: "schedulingAssignments",
  initialState,
  reducers: {
    setSchedulingAssignments(
      state,
      action: PayloadAction<SchedulingAssignment[]>,
    ) {
      state.assignments = action.payload;
    },
    setSchedulingLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    removeSchedulingAssignment(state, action: PayloadAction<string>) {
      state.assignments = state.assignments.filter(
        (a) => a.id !== action.payload,
      );
    },
    updateSchedulingAssignment(
      state,
      action: PayloadAction<SchedulingAssignment>,
    ) {
      const idx = state.assignments.findIndex(
        (a) => a.id === action.payload.id,
      );
      // Merge rather than replace — PATCH responses may omit fields that were
      // not changed, so we preserve the existing values for missing fields.
      if (idx !== -1)
        state.assignments[idx] = {
          ...state.assignments[idx],
          ...action.payload,
        };
    },
    addSchedulingAssignments(
      state,
      action: PayloadAction<SchedulingAssignment[]>,
    ) {
      const existingIds = new Set(state.assignments.map((a) => a.id));
      for (const a of action.payload) {
        if (!existingIds.has(a.id)) state.assignments.push(a);
      }
    },
  },
});

export const {
  setSchedulingAssignments,
  setSchedulingLoading,
  removeSchedulingAssignment,
  updateSchedulingAssignment,
  addSchedulingAssignments,
} = schedulingAssignmentsSlice.actions;
export default schedulingAssignmentsSlice.reducer;
